import { AAGUID } from '@interticket/core';
import { UserStatus } from '@core/enums/user/user-status.enum';
import { Gender } from '@core/enums/gender/gender.enum';
import { IUserProfile } from '@core/interfaces/user/user-profile.interface';
import { Customer } from '../customer/customer.model';

export class UserProfile implements IUserProfile {

  readonly id: AAGUID;
  readonly maidenName: string;
  readonly emailConfirmed: boolean;
  readonly createdAt: string;
  readonly status: UserStatus;
  readonly email: string;
  readonly picture: AAGUID;
  readonly firstName: string;
  readonly lastName: string;
  readonly motherName: string;
  readonly birthPlace: string;
  readonly birthDate: string;
  readonly gender: Gender;
  readonly birthName: string;
  readonly phoneNumber: string;
  readonly roles: string[];
  readonly partnerName: string;
  readonly customer: Customer;

  constructor(iUserProfile: IUserProfile) {
    this.id = iUserProfile.id;
    this.maidenName = iUserProfile.maidenName;
    this.emailConfirmed = iUserProfile.emailConfirmed;
    this.createdAt = iUserProfile.createdAt;
    this.status = iUserProfile.status;
    this.email = iUserProfile.email;
    this.picture = iUserProfile.picture;
    this.firstName = iUserProfile.firstName;
    this.lastName = iUserProfile.lastName;
    this.motherName = iUserProfile.motherName;
    this.birthPlace = iUserProfile.birthPlace;
    this.birthDate = iUserProfile.birthDate;
    this.gender = iUserProfile.gender;
    this.birthName = iUserProfile.birthName;
    this.phoneNumber = iUserProfile.phoneNumber;
    this.roles = Array.isArray(iUserProfile.roles) ? iUserProfile.roles : [];
    this.partnerName = iUserProfile.partnerName;
    this.customer = iUserProfile.customer ? new Customer(iUserProfile.customer) : null;
  }

}
